var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" History "),_c('ul',_vm._l((_vm.history),function(item,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.getHistoryCost(item)))+" "+_vm._s(_vm._f("formatDateTime")(item.date))+" - "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }